import React from 'react';
import Modal from 'react-modal';
import Cookies from 'js-cookie';

import '../css/SystemIntegratorView.css';

// si boxes data view page component


const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    minHeight: '100%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '2%',
    marginLeft: '260px',
    marginTop: '3%',
    background: 'white',
    // background: 'none !important'
  },
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "none"
  },
};


const Styles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)', 
    width: '40%',
    minHeight: '50%',
    maxHeight: '70%',
    overflow: 'auto',
    padding: '2%',
  }
};

const SiRating = [
  { label: 'A++' },
  { label: 'A' },
  { label: 'B+' },
];

const SiRelationStat = [
  { label: 'Hot' },
  { label: 'Warm' },
  { label: 'Dry' },
  { label: 'Cold' },
];


export default class SIOkasBoxes extends React.Component{
  constructor(props) {
  super(props);

  this.state = {
    modalIsOpen: this.props.activeModal,
    noOfParams: [],
    modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
    SiUsername: this.props.siCurrentData.si_userName,
    SiName: this.props.siCurrentData.si_name,
    SiEmail: this.props.siCurrentData.si_email,
    SiCompany: this.props.siCurrentData.si_company,
    SiMobile: this.props.siCurrentData.si_mobile,
    SiArea: this.props.siCurrentData.si_area,
    SiAddress: this.props.siCurrentData.si_address,
    SiDescription: this.props.siCurrentData.si_description,
    SiRating: this.props.siCurrentData.si_rating,
    SiRelationStat: this.props.siCurrentData.si_relationstatus,
    errorMessage: [],
    allBoxes: []
  };
  this.openModal = this.openModal.bind(this);
  this.afterOpenModal = this.afterOpenModal.bind(this);
  this.closeModal = this.closeModal.bind(this);
}

openModal() {
  this.setState({modalIsOpen: true});
}    

afterOpenModal() {

}

closeModal() {
  this.setState({
    modalStateAftereOpen: 'animated animated-duration-custom slideOutUp'
  },()=>{
    setTimeout(()=>{
      this.setState({
        modalIsOpen: false
      })
    }, 500);

  })
}

componentDidMount(){
  console.log(this.props)
  console.log(this.props.buildingId)
  this.fetchAllBoxes()
}

fetchAllBoxes = () => {
  var tokenStored = localStorage.getItem('token');
  tokenStored = `Token ${tokenStored}`;
  let bodyToQuery = {
    'user': this.state.SiUsername,
    'building_id': this.props.buildingId
  }
  console.log(bodyToQuery)
  var headers = {
    'Content-Type': 'application/json',
    "Access-Control-Allow-Origin": "*",
    'X-CSRFToken': localStorage.getItem('csrftoken'),
    'Authorization': tokenStored
  }
  fetch(`/cloud/siboxdetails/`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(bodyToQuery)
  })
             .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
    .then(data => {
      this.setState({
        allBoxes: data
      })
    })
    .catch((err)=>{
      console.log(err)
    })
}  

renderAllBoxes = () => {
  let element = this.state.allBoxes.map((e,index)=>{
      return     (
         <tr key={index}>
      <td>{index+1}</td>
      <td>{e.okas_box_type}</td>
      <td>{e.license_id}</td>
      <td>{e.registration_id}</td>
    </tr>)
  })
  return element
}

render(){
        return (
          <React.Fragment>
            <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}          
          className={this.state.modalStateAftereOpen}      
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
                <i class="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <h3 className="modal-heading text-uppercase mb-0 mt-4">{this.state.SiName}'s OKAS Boxes</h3>
<div className="row mt-3">
            <table className="table">
                <thead className="tableHeaderColor">
                  <tr>
                    <th scope="col">Serial No</th>
                    <th scope="col">OKAS Box type</th>
                    <th scope="col">License ID</th>
                    <th scope="col">Registraion ID</th>
                  </tr>
                </thead>
                <tbody  style={{height: '70%'}}>
                {this.renderAllBoxes()}            
                </tbody>
              </table>
              <div className="row w-100 mt-4 mb-4">
              <div className="float-right ml-auto">
               <div className="btn modal-cancel-btn mx-2 px-5 " onClick={this.closeModal}>Close</div>              
             </div>
              </div>
          
</div>

          
        </Modal>
          </React.Fragment>
        );
    }
}
